class MenuToggler {
	/**
	 * Connects a toggle button with a menu.
	 *
	 * @param {HTMLElement|string} menuSelector
	 * @param {string} toggleSelector
	 * @param {string} toggledClassName
	 */
	constructor(menuSelector, toggleSelector, toggledClassName = "hidden") {
		this.menu =
			menuSelector instanceof HTMLElement
				? menuSelector
				: document.querySelector(menuSelector)

		this.toggleButtons = document.querySelectorAll(toggleSelector)

		this.toggledClassName = toggledClassName

		this.toggleButtons.forEach(toggle => toggle.addEventListener("click", this.handler.bind(this)))

		this.submenuToggles = this.menu.querySelectorAll('.submenu-toggle')
		this.submenuToggles.forEach(toggle => toggle.addEventListener("click", this.submenuHandler.bind(this)))
	}

	handler(event) {
		event.preventDefault()
		this.toggle()
	}

	toggle() {
		this.menu.classList.toggle(this.toggledClassName)
	}

	submenuHandler(event) {
		event.preventDefault()
		this.submenuToggle(event)
	}

	submenuToggle(event) {
		event.preventDefault()
		let menuItem = event.target.closest('.menu-item-has-children')
		let submenu = menuItem.querySelector('.sub-menu')

		submenu.classList.toggle('hidden')
	}
}

export { MenuToggler }
